import { useEffect, useState } from 'react';
import { getIntegrationConnections } from '../utils/clients/walnutApi';
import { handleAsyncState } from '../utils/handleAsyncState';
import type { SendToIntegrationContainerProps } from './useSendToIntegrationLogic';
import type { IntegrationConnection } from '../types';

export const useGetConnectedConnections = (
  sendToIntegrationProps: SendToIntegrationContainerProps
) => {
  const [connectedConnectionsLoading, setConnectedConnectionsLoading] =
    useState(false);
  const [connectedConnectionsError, setConnectedConnectionsError] =
    useState<Error | null>(null);
  const [connectedConnections, setConnectedConnections] = useState<
    IntegrationConnection[]
  >([]);

  useEffect(() => {
    if (!sendToIntegrationProps.userEnterpriseId) {
      return;
    }

    async function loadConnectedConnections() {
      const bearerToken = await sendToIntegrationProps.authFn();

      const allIntegrationConnections = await getIntegrationConnections({
        apiHostname: sendToIntegrationProps.apiHostname,
        token: bearerToken,
        enterpriseId: sendToIntegrationProps.userEnterpriseId
      });

      // Filter to only have connected connections and create a map of connections, for the faster search
      const integrationConnections = allIntegrationConnections.filter(
        connection => connection.status === 'connected'
      );

      setConnectedConnections(integrationConnections);
    }

    handleAsyncState(
      loadConnectedConnections,
      setConnectedConnectionsLoading,
      setConnectedConnectionsError
    );
  }, [sendToIntegrationProps.userEnterpriseId]);

  return {
    connectedConnections,
    connectedConnectionsLoading,
    connectedConnectionsError
  };
};
